// import { useLoader } from "@react-three/fiber";
// import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

import { const_var } from "../../../../../redux/reducers/reducer";


const HandleOneModel = ({ width, handlePlacement, handleModel }) => {
    // const baseUrl = process.env.REACT_APP_BASE_URL;
    // const { nodes } = useLoader(GLTFLoader, baseUrl+'/assets/glbModels/handle_sphere.glb');
    
    return (
        <>
          {const_var.loadGltObj!=undefined &&
            <>
                <mesh geometry={const_var.loadGltObj.geometry} position={[(width === 0 ? -0.2 : handlePlacement == "left" ? (width / 2 - 0.3): (-width / 2 + 0.3)), 0, 0.27]} scale={[0.003, 0.003, 0.003]}>
                    <meshStandardMaterial color={'#666666'} roughness={0.2} metalness={0.3} />
                </mesh>
                <mesh geometry={const_var.loadGltObj.geometry} position={[(width === 0 ? -0.2 : handlePlacement == "left" ? (width / 2 - 0.3): (-width / 2 + 0.3)), 0, 0.03]} rotation={[0, Math.PI, 0]} scale={[0.003, 0.003, 0.003]}>
                    <meshStandardMaterial color={'#666666'} roughness={0.2} metalness={0.3} />
                </mesh>
            </>
          }
        </>
    )
}

export default HandleOneModel;